"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SVG = _interopRequireDefault(require("./SVG"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InfoIcon = function InfoIcon(_ref) {
  var width = _ref.width,
      height = _ref.height,
      style = _ref.style,
      viewBox = _ref.viewBox,
      fill = _ref.fill,
      className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_SVG.default, {
    style: style,
    width: width || '32',
    height: height || '32',
    viewBox: viewBox || '0 0 32 32',
    fill: fill,
    className: className,
    path: "M7 16C7 20.9709 11.0291 25 16 25C20.9709 25 25 20.9709 25 16C25 11.0291 20.9709 7 16 7C11.0291 7 7 11.0291 7 16ZM6 16C6 10.4769 10.4769 6 16 6C21.5231 6 26 10.4769 26 16C26 21.5231 21.5231 26 16 26C10.4769 26 6 21.5231 6 16ZM15.5 14C15.5 13.7239 15.7239 13.5 16 13.5C16.2761 13.5 16.5 13.7239 16.5 14V21C16.5 21.2761 16.2761 21.5 16 21.5C15.7239 21.5 15.5 21.2761 15.5 21V14ZM16.5 11.5C16.5 11.776 16.276 12 16 12C15.724 12 15.5 11.776 15.5 11.5C15.5 11.224 15.724 11 16 11C16.276 11 16.5 11.224 16.5 11.5Z"
  });
};

var _default = InfoIcon;
exports.default = _default;